import type { TemplateMeta } from '../../types';
import { Box1RowIcon } from './Icon';

export const yearly3BoxMonthCardMeta: TemplateMeta = {
  name: '3 Box Grid',
  orientation: 'portrait',
  Icon: Box1RowIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Date range',
  eventListDisplayFullLabel: 'Full year',
  eventListRangePicker: 'month-range',
};
